module.exports = __webpack_public_path__ + "static/media/Amazon.e6529a42.jpg";